import { ForgotPassword } from "shared/auth/forgotPassword";
import { CenteredContainer } from "components/centeredContainer";
import { useToast } from "shared/toast/useToast";

export default function ForgotPasswordPage() {
  const { success } = useToast();
  function handleSuccess() {
    success("Please check your email!");
  }
  return (
    <CenteredContainer>
      <ForgotPassword handleSuccess={handleSuccess} />
    </CenteredContainer>
  );
}
